import {CTA} from '@volkswagen-onehub/components-core';
import {Info} from '@volkswagen-onehub/icons-core';
import {InfoButtonProps} from '@volkswagen-onehub/whitelabel-e-mobility-commons';
import * as React from 'react';
import {BrandThemeProvider} from '../theme';

export const InfoButton = React.forwardRef<HTMLButtonElement, InfoButtonProps>(
  (props, ref): JSX.Element => {
    const {onClick, ariaLabel, testId} = props;
    return (
      <CTA
        onClick={onClick}
        emphasis="tertiary"
        tag="button"
        size="small"
        aria-label={ariaLabel}
        data-testid={testId}
        icon={<Info title={ariaLabel} />}
        ref={ref}
      ></CTA>
    );
  }
);

export const InfoButtonInverted = React.forwardRef<
  HTMLButtonElement,
  InfoButtonProps
>((props, ref): JSX.Element => {
  return (
    <BrandThemeProvider theme="inverted">
      <InfoButton {...props} ref={ref} />
    </BrandThemeProvider>
  );
});
